import { axios } from '@Root/API'

export const edit = (id, payload) => {
  return axios.post(`upload/applications/attachment/${id}`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
